import React, { PropTypes } from "react";
import ComponentRegistry from "Fratello/Common/ComponentRegistry";

export default function VisualView({ current, labels, onPrev, onNext }) {
    const Image = ComponentRegistry.get("Image");
    return (
        <section className="carousel">
            <a href={current.url} className="carousel-detail-image-wrapper">
                <Image className="carousel-detail-image" src={current.src} name={current.label} />
                <div className="carousel-box">
                    <h2 className="carousel-title">{current.label}</h2>
                    <span className="carousel-more">{labels.read_more}</span>
                </div>
            </a>
            <a href="#next-visual" className="btn-next" onClick={onNext}><span className="sr-only">{labels.next}</span><i className="icon icon-arrow-right"></i></a>
            <a href="#prev-visual" className="btn-prev" onClick={onPrev}><span className="sr-only">{labels.previous}</span><i className="icon icon-arrow-left"></i></a>
        </section>
    );
}
VisualView.propTypes = {
    current: PropTypes.shape({
        label: PropTypes.string,
        url: PropTypes.string,
        src: PropTypes.string.isRequired,
    }),
    labels: PropTypes.shape({
        previous: PropTypes.string,
        next: PropTypes.string,
        read_more: PropTypes.string
    }),
    onPrev: PropTypes.func,
    onNext: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/ImagesGallery/Views/VisualView.jsx